import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  loading: false,
  discountLoader: false,
  error: null,
  message: null,
  discountInfo: null,
  isDiscountApplied: false,
  autoAppliedDiscounts: [],
};

const discountsSlice = createSlice({
  name: "discounts",
  initialState,
  reducers: {
    validateDiscount: (state) => {
      state.discountLoader = true;
      state.error = false;
    },
    validateDiscountSuccess: (state, action) => {
      state.discountLoader = false;
      state.error = false;
      state.message = action.payload;
    },
    validateDiscountFailure: (state, action) => {
      state.discountLoader = false;
      state.error = action.payload;
    },
    setDiscountCode: (state, action) => {
      state.error = null;
      state.discountInfo = action.payload;
    },
    removeDiscountCode: (state) => {
      state.discountInfo = null;
      state.error = null;
    },
    setCoponValidation: (state, action) => {
      state.isDiscountApplied = action.payload;
    },
    setAutoAppliedDiscounts: (state, action) => {
      const uniqueAutoAppliedDiscounts = [...new Set([...(state?.autoAppliedDiscounts ||[]), action.payload])];
      state.autoAppliedDiscounts = uniqueAutoAppliedDiscounts
    },
    removeAutoAppliedDiscounts: (state) => {
      state.autoAppliedDiscounts = [];
    },
  },
});

export const {
  setCoponValidation,
  validateDiscount,
  validateDiscountFailure,
  validateDiscountSuccess,
  setDiscountCode,
  removeDiscountCode,
  setAutoAppliedDiscounts,
  removeAutoAppliedDiscounts,
} = discountsSlice.actions;
export default discountsSlice.reducer;
